import { g_logistikCart } from '@chancenlogistik/client/globalSubjects.js';
import { LogistikAccessToken } from '@chancenwerk/db/tokens.js';
import { Observable, map } from 'rxjs';
import { activeToken } from './globalSubjects.js';

export const g_getTotalOrderQuantity = (): Observable<number> => {
  return g_logistikCart.pipe(map(cart => cart.items.reduce((sum, item) => sum + item.quantity, 0)));
};

export const g_getMaxOrderQuantity = async (token?: string) => {
  const code = activeToken.value;
  const { maxOrderQuantity } = await LogistikAccessToken.getByToken(token ? +token : +code)({ maxOrderQuantity: 1 });
  return maxOrderQuantity ?? 0;
};
